import { useEffect, useState } from 'react';
import { motion } from 'framer-motion'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'components/constants/animation-properties';
import Container from 'components/common/Container';
import { jsonAxios } from 'components/axios';
import { INews } from 'types/news';
import Card from 'components/news/list/Card';

const Fifth = () => {
    const [list, setList] = useState<INews[]>([]);

    useEffect(() => {
        init()
    }, [])

    const init = () => {
        jsonAxios.get(`articles`).then(res => {
            if (res.data.code === 200) {
                const newData = res.data.data
                setList(newData.length > 3 ? newData.slice(0, 3) : newData)
            }
        })
    }

    return (
        <Container className='flex flex-col gap-10'>
            <div>
                <motion.div
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                    className='flex justify-center items-center bg-primary mb-4.5 py-2.5 rounded max-w-[156px] text-white'
                >
                    News & Issues
                </motion.div>
                <motion.h2
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                    className='font-bold text-32 mobile:text-2xl'>
                    펄스온쉽 <span className='text-primary'>물류뉴스</span>
                </motion.h2>
            </div>
            {

                list.length > 0 ?
                    <div className='tablet:flex tablet:flex-col gap-6 grid grid-cols-[repeat(auto-fill,_minmax(400px,_1fr))]'>
                        {
                            list.map((item, idx) => (
                                <Card item={item} idx={idx} key={idx} />
                            ))
                        }
                    </div> :
                    <div className='flex justify-center items-center w-full h-96'>
                        데이터가 없습니다.
                    </div>
            }
        </Container>
    )
}

export default Fifth